// RPC Configuration for different blockchain networks
export const RPC_CONFIG = {
  ethereum: {
    chainId: 1,
    name: 'Ethereum',
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    endpoints: [
      'https://eth.llamarpc.com',
      'https://rpc.ankr.com/eth',
      'https://ethereum.publicnode.com',
      'https://cloudflare-eth.com', // Fallback
    ]
  },
  bsc: {
    chainId: 56,
    name: 'Binance Smart Chain',
    currency: 'BNB',
    explorerUrl: 'https://bscscan.com',
    endpoints: [
      'https://bsc-dataseed1.binance.org/',
      'https://bsc-dataseed2.binance.org/',
      'https://bsc-dataseed3.binance.org/',
      'https://bsc-dataseed4.binance.org/',
    ]
  },
  polygon: {
    chainId: 137,
    name: 'Polygon',
    currency: 'MATIC',
    explorerUrl: 'https://polygonscan.com/',
    endpoints: [
      'https://polygon-rpc.com/',
      'https://polygon.llamarpc.com',
      'https://rpc-mainnet.maticvigil.com/',
    ]
  },
  tron: {
    chainId: 728126428,
    name: 'Tron',
    currency: 'TRX',
    explorerUrl: 'https://tronscan.org',
    endpoints: [
      'https://api.trongrid.io',
      'https://api.shasta.trongrid.io', // Testnet fallback
    ]
  }
};

// Get the primary RPC URL for a given chain ID
export const getPrimaryRpcUrl = (chainId: number): string => {
  const config = Object.values(RPC_CONFIG).find(c => c.chainId === chainId);
  return config?.endpoints[0] || '';
};

// Get all RPC URLs for a given chain ID
export const getAllRpcUrls = (chainId: number): string[] => {
  const config = Object.values(RPC_CONFIG).find(c => c.chainId === chainId);
  return config?.endpoints || [];
};

// Get network info by chain ID
export const getNetworkInfo = (chainId: number) => {
  return Object.values(RPC_CONFIG).find(c => c.chainId === chainId);
}; 